import { ProtectedJsonAPI } from '.'

export const Documents = ProtectedJsonAPI.extend(
  'documents',
  {
    show:    endpoint => endpoint.path(({name}) => name).method('get'),
    update:  endpoint => endpoint.path(({name}) => name).method('put'),
  }
)